import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import Button from '../common/Button';
import Logo from '../illustrations/Logo';
import { useNavigate } from 'react-router-dom';

const FinalCTA = () => {
  const [ref, isVisible] = useScrollAnimation();
  const navigate = useNavigate();

  return (
    <section ref={ref} className="py-40 px-6 bg-gradient-to-b from-black to-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <Logo className="absolute top-20 left-20 w-64 h-64 text-white" />
      </div>

      <div className={`max-w-4xl mx-auto text-center relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
        <h2 className="text-5xl font-bold mb-6">
          Fylo is built for creators,<br />
          who believe
          interaction is art.
        </h2>
        <p className="text-xl text-gray-400 mb-12">
          Whether it's onboarding, feedback, or surveys.<br />
          Fylo helps you collect data beautifully.
        </p>

        <Button primary className="px-8 py-4 text-lg" onClick={() => {
          navigate('/signup');
        }}>Start Building</Button>
        <p className="text-sm text-gray-500 mt-4">Design your first 5 forms free.</p>
      </div>
    </section>
  );
};

export default FinalCTA;